function setCheckoutArea(enable) {
  let mainCheckoutButtons = document.querySelectorAll("button#checkout");
  let checkoutButtons = document.querySelector("div#dynamic-checkout-cart");
  for (checkoutButton of mainCheckoutButtons) { checkoutButton.disabled = !enable; }
  checkoutButtons.hidden = !enable;
}

function setupCheckbox() {
  let agreeCheckbox = document.querySelector("input#agree");
  agreeCheckbox.onclick = (checkbox) => {
    console.log(`CHECKOUT CLICKED WITH VALUE ${checkbox.target.checked}`)
    setCheckoutArea(checkbox.target.checked)
  }
}

setupCheckbox();
setCheckoutArea(false);